<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
// Components
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import SharedDeleteConfirmDialog from "@/components/shared/SharedDeleteConfirmDialog.vue";
//import SharedDropdown from "@/components/shared/SharedDropdown.vue";
//import SharedDropdown from "@/components/shared/SharedDropdown.vue";
import HeaderTitle from "@/components/layout/HeaderTitle";
import { useAutomaticSearch } from "@/app/composables/useAutomaticSearch";

// Services
// Services
import HolidayIncompatibleService from '@/api/services/holidayIncompatibility.service';
import EmployeeService from '@/api/services/employee.service';
import Notification from '@/utils/plugins/NotificationService';

import { getCurrentInstance, onMounted, ref } from "vue";
import { useUiStore } from "@/app/stores/uiStore";


const uiStore = useUiStore();

const instance = getCurrentInstance();

const holidayIncompatibility = ref({
  name: '',
  minNumberEmployees: 0,
  employees: []
});

const holidayIncompatibilities = ref([]);

const holidayIncompatibilityName = ref('');

const employeeName = ref('');

const params = ref({});

const page = ref(1);

const itemsPerPage = ref(10);

const totalResults = ref(0);

const searchName = ref('');

const deleteDialogShown = ref(false);

const isUpdateHoliday = ref(false);

const dataSynchronized = ref(false);

function nameRule(rule, value, callback) {
  if (!value) {
    newHolidayIncompatibilityRules.value.name.error = true;
    callback(new Error("Debe especificar un nombre"));
  } else {
    newHolidayIncompatibilityRules.value.name.error = false;
    callback();
  }
}

function minNumberEmployeesRule(rule, value, callback) {
  if (value == null || value < 0) {
    newHolidayIncompatibilityRules.value.minNumberEmployees.error = true;
    callback(new Error("Debe especificar un mínimo de empleados válido"));
  } else {
    newHolidayIncompatibilityRules.value.minNumberEmployees.error = false;
    callback();
  }
}

function employeesRule(rule, value, callback) {
  if (!value || value.length <= 0) {
    newHolidayIncompatibilityRules.value.employees.error = true;
    callback(new Error("Debe seleccionar al menos un empleado"));
  } else {
    newHolidayIncompatibilityRules.value.employees.error = false;
    callback();
  }
}

const newHolidayIncompatibilityRules = ref({
  name: {
    required: true,
    validator: nameRule,
    error: false,
    trigger: "blur"
  },
  minNumberEmployees: {
    required: true,
    validator: minNumberEmployeesRule,
    error: false,
    trigger: "blur"
  },
  employees: {
    required: true,
    validator: employeesRule,
    error: false,
    trigger: "blur"
  }
});

const selectedHolidayIncompatibility = ref({
  name: '',
  minNumberEmployees: 0,
  employees: []
});

const selectedEmployee = ref(null);

const selectedHolidayIncompatibilityText = ref('');

const showModalConfigIncompatibility = ref(false);

const showModalEmployees = ref(false);

const searchNameModalEmployees = ref('');

const allEmployeesList = ref([]);

const allEmployeesListTotal = ref(0);

const restart = ref(false);
const { beginRequest, isCurrentRequest } = useAutomaticSearch([holidayIncompatibilityName, employeeName], () => {
  page.value = 1;
  getHolidayIncompatibilities();
});

async function getHolidayIncompatibilities() {
  params.value = {
    page: page.value,
    itemsPerPage: itemsPerPage.value
  };
  if (holidayIncompatibilityName.value) {
    params.value.name = holidayIncompatibilityName.value.toLowerCase();
  }
  if (employeeName.value) {
    params.value.orSearch_fullName = employeeName.value.toLowerCase();
  }

  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  dataSynchronized.value = false;
  const requestId = beginRequest();
  await HolidayIncompatibleService.getHolidayIncompatibilities(params.value).then(res => {
    if (!isCurrentRequest(requestId)) return;
    holidayIncompatibilities.value = res.data['hydra:member'];
    totalResults.value = res.data['hydra:totalItems'];
  }).catch(() => {
    if (isCurrentRequest(requestId)) Notification.addNotification('Error al obtener las incompatibilidades', 'error', 6000);
  });
  // this.$uiStore.setLoading(false);
  uiStore.stopLoading();
  if (isCurrentRequest(requestId)) dataSynchronized.value = true;
}

function deleteDialog(holidayIncompatibility, employee) {
  selectedHolidayIncompatibility.value = holidayIncompatibility;
  selectedEmployee.value = employee;
  deleteDialogShown.value = true;
  selectedHolidayIncompatibilityText.value = selectedHolidayIncompatibility.value.name + ' --- ' + selectedEmployee.value.name + ' ' + selectedEmployee.value.lastName;
  // this.deleteHolidayIncompatibility(holidayIncompatibility, employee);
}

function deleteSelectedHolidayIncompatibility(holidayIncompatibility, employee) {
  if (selectedHolidayIncompatibility.value.employees.length === 1) {
    deleteHolidayIncompatibility(selectedHolidayIncompatibility.value);
  } else {
    let employees = holidayIncompatibility.employees.filter(function (emp) {
      return emp['@id'] !== employee['@id'];
    });
    holidayIncompatibility.employees = employees;
    saveHolidayIncompatibility(holidayIncompatibility);
  }
}

async function deleteHolidayIncompatibility(holidayIncompatibility) {
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  holidayIncompatibilities.value = [];
  await HolidayIncompatibleService.deleteHolidayIncompatibility(holidayIncompatibility.id).then(() => {
    Notification.addNotification('Incompatibilidad eliminada correctamente.', 'success', 6000);
  }).catch(() => {
    Notification.addNotification('Error al intentar eliminar la incompatibilidad seleccionado.', 'success', 6000);
    uiStore.stopLoading();
  });
  // this.$uiStore.setLoading(false);
  uiStore.stopLoading();
  selectedHolidayIncompatibility.value = {};
  selectedEmployee.value = null;
  deleteDialogShown.value = false;
  getHolidayIncompatibilities();
}

async function updateHolidayIncompatibility(holidayIncompatibility) {
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  if (holidayIncompatibility.employees.length === 0) {
    deleteHolidayIncompatibility(holidayIncompatibility);
    uiStore.stopLoading();
    await getHolidayIncompatibilities();
    return;
  }
  await HolidayIncompatibleService.updateHolidayIncompatibility(holidayIncompatibility, holidayIncompatibility.id).then(() => {
    Notification.addNotification('Incompatibilidad actualizada correctamente', 'success', 6000);
    selectedHolidayIncompatibility.value = {};
    selectedEmployee.value = {};
    deleteDialogShown.value = false;
  }).catch(() => {
    Notification.addNotification('Error al actualizar la incompatibilidad', 'error', 6000);
    uiStore.stopLoading();
  });
  // this.$uiStore.setLoading(false);
  uiStore.stopLoading();
  await getHolidayIncompatibilities();
}

async function createHolidayIncompatible(holidayIncompatibility) {
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  await HolidayIncompatibleService.createHolidayIncompatibility(holidayIncompatibility).then(() => {
    Notification.addNotification('Incompatibilidad creada correctamente', 'success', 6000);
  }).catch(() => {
    Notification.addNotification('Error al crear la incompatibilidad', 'error', 6000);
    uiStore.stopLoading();
  });
  // this.$uiStore.setLoading(false);
  uiStore.stopLoading();
  await getHolidayIncompatibilities();
}

function openModalConfigHolidayIncompatibility(holidayIncompatibility) {
  if (holidayIncompatibility && holidayIncompatibility.id) {
    selectedHolidayIncompatibility.value = holidayIncompatibility;
    isUpdateHoliday.value = true;
  } else {
    selectedHolidayIncompatibility.value = {
      name: '',
      minNumberEmployees: 0,
      employees: []
    };
  }
  showModalConfigIncompatibility.value = true;
}

function closeModalConfigHolidayIncompatibility() {
  selectedHolidayIncompatibility.value = {};
  showModalConfigIncompatibility.value = false;
  isUpdateHoliday.value = false;
  newHolidayIncompatibilityRules.value.name.error = false;
  newHolidayIncompatibilityRules.value.minNumberEmployees.error = false;
  newHolidayIncompatibilityRules.value.employees.error = false;
  if (restart.value) getHolidayIncompatibilities();
}

function requestSaveConfigHolidayIncompatibility(holidayIncompatible) {
  saveHolidayIncompatibilityWithFormValidation(holidayIncompatible);
}

function addEmployeeFromConfigModal() {
  openModalEmployees();
}

function deleteEmployeeFromConfigModal(incompatibility, employee) {
  restart.value = true;
  selectedHolidayIncompatibility.value.employees = incompatibility.employees.filter(function (emp) {
    return emp['@id'] !== employee['@id'];
  });
}

async function openModalEmployees() {
  await getEmployees();
  showModalEmployees.value = true;
}

function closeModalEmployees() {
  showModalEmployees.value = false;
}

function isEmployeeSelected(itemSelected) {
  if (selectedHolidayIncompatibility.value.employees) {
    return selectedHolidayIncompatibility.value.employees.some(member => member.id === itemSelected.id);
  }
  return false;
}

function addEmployeeToConfigIncompatibility(employee) {
  if (selectedHolidayIncompatibility.value != null) {
    if (selectedHolidayIncompatibility.value.employees) {
      let existMember = selectedHolidayIncompatibility.value.employees.findIndex(member => member.id === employee.id);
      if (existMember == -1) {
        selectedHolidayIncompatibility.value.employees.push(employee);
        Notification.addNotification({
          type: 'success',
          message: 'Empleado añadido.',
          duration: 6000
        });
      } else {
        selectedHolidayIncompatibility.value.employees.splice(existMember, 1);
        Notification.addNotification({
          type: 'warning',
          message: 'Empleado eliminado',
          duration: 6000
        });
      }
    } else {
      selectedHolidayIncompatibility.value.employees.push(employee);
      Notification.addNotification({
        type: 'success',
        message: 'Empleado añadido',
        duration: 6000
      });
    }
  }
  restart.value = true;
}

function filterEmployeesByName(name) {
  delete params.value.name;
  if (name && name.length > 0) {
    name = name.toLowerCase();
    params.value = {
      ...params.value,
      orSearch_fullName: name
    };
  } else {
    delete params.value['orSearch_fullName'];
  }
  page.value = 1;
  getEmployees();
  delete params.value.name;
}

function getEmployees() {
  delete params.value.name;
  params.value = {
    ...params.value,
    page: page.value,
    itemsPerPage: itemsPerPage.value,
    active: true
  };
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  EmployeeService.getEmployees(params.value).then(res => {
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    allEmployeesList.value = res.data['hydra:member'];
    allEmployeesListTotal.value = res.data['hydra:totalItems'];
  }).catch(() => {
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    Notification.addNotification('Error al obtener los empleados', 'error', 6000);
  });
}

function saveHolidayIncompatibilityWithFormValidation(holidayIncompatibility) {
  instance.proxy.$refs["newHolidayIncompatibilityForm"].validate(valid => {
    if (valid) {
      saveHolidayIncompatibility(holidayIncompatibility);
    } else {
      return false;
    }
  });
}

function saveHolidayIncompatibility(holidayIncompatibility) {
  if (holidayIncompatibility.id) {
    let employees = [];
    holidayIncompatibility.employees.forEach(employee => {
      employees.push(employee['@id']);
    });
    holidayIncompatibility.employees = employees;
    dataSynchronized.value = false;
    updateHolidayIncompatibility(holidayIncompatibility);
  } else {
    let employees = [];
    holidayIncompatibility.employees.forEach(employee => {
      employees.push(employee['@id']);
    });
    holidayIncompatibility.employees = employees;
    if (holidayIncompatibility.employees.length > 0) {
      createHolidayIncompatible(holidayIncompatibility);
      restart.value = true;
    } else {
      Notification.addNotification({
        type: 'error',
        message: 'No se puede crear una incompatibilidad sin empleados',
        duration: 6000
      });
    }
  }
  closeModalConfigHolidayIncompatibility();
}

function closeStatusConfirmationModal() {
  deleteDialogShown.value = false;
  selectedHolidayIncompatibility.value = {};
  selectedEmployee.value = null;
}

onMounted(() => {
  getHolidayIncompatibilities();
});
</script>

<template>
  <div class="holiday-incompatibilities">
    <HeaderTitle title="Ajustes" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/group.svg" width="30" alt="">
      <div class="title-text pl-4">
        Vacaciones incompatibles
      </div>
    </div>
    <el-card class="card-search w-100 wback" body-style="padding:0" style="height: auto !important;">
      <div class="row mx-5 master-search-row">
        <div class="container-holiday-incompatibilities">
          <form @submit.prevent>

            <div class="row align-items-end">
              <div class="col-md-4 col-12">
                <div class="form-item">
                  <label for="holidayIncompatibilityName" class="w-100 mb-2">Nombre incompatibilidad</label>
                  <el-input id="holidayIncompatibilityName" clearable v-model="holidayIncompatibilityName" placeholder="Nombre Incompatibilidad" />
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-item">
                  <label for="employeeName" class="w-100 mb-2">Nombre empleado</label>
                  <el-input id="employeeName" clearable v-model="employeeName" placeholder="Nombre" />
                </div>
              </div>
              <div class="col-md-4 col-12 d-flex justify-content-end master-search-actions">
                <button type="button" class="btn btn_darkpink btn-search master-create-button"
                  @click="openModalConfigHolidayIncompatibility()">
                  Nueva Incompatibilidad
                </button>
              </div>
            </div>

            <!--
            <div class="form-item">
                <div class="row text-center">
                    <div class=col-md-6>
                        <div class="row">
                            <div class="col-md-2">
                                <label class="label-state">Estado:</label>
                            </div>
                            <div class="col-md-10">
                                <div class="colsd">
                                    <SharedDropdown
                                            id="status"
                                            v-model="selectedStatusFilter"
                                            :items="statusOptions"
                                            :selected="selectedStatusFilter"
                                            @selectItem="filterByStatus($event)"
                                            data-vv-as="selectedStatusFilter"
                                            :rules="{ required: false }"
                                            data-vv-name="statusOptions"
                                            :label="'ddd'"
                                            :param="'name'"
                                            :color="'light'"
                                            :title="'Todos'"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            -->
          </form>
        </div>
      </div>
    </el-card>
    <div class="table table-not-mobile">
      <div v-if="dataSynchronized && holidayIncompatibilities && holidayIncompatibilities.length > 0">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Empleado</th>
              <th class="master-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="holidayIncompatibility in holidayIncompatibilities">
              <tr v-for="employee in holidayIncompatibility.employees"
                :id="holidayIncompatibility.id + '-' + employee.id"
                :key="holidayIncompatibility.id + '-' + employee.id" class="pointer"
                @click="openModalConfigHolidayIncompatibility(holidayIncompatibility)">
                <td>
                  {{ holidayIncompatibility.name }}
                </td>
                <td>
                  {{ employee.name }} {{ employee.lastName }}
                </td>
                <td class="master-actions-col">
                  <!-- <div class="buttons d-inline-flex" v-if="user && ifIsInArray('ROLE_SUPER_ADMIN', user.rol)">-->
                  <div class="buttons d-inline-flex">
                    <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Editar"
                      @click.stop="openModalConfigHolidayIncompatibility(holidayIncompatibility);">
                      <font-awesome-icon icon="circle" style="color: #f7d20e" />
                      <font-awesome-icon icon="plus" class="fa-inverse" transform="shrink-6" />
                    </font-awesome-layers>
                    <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Eliminar"
                      @click.stop="deleteDialog(holidayIncompatibility, employee);">
                      <font-awesome-icon icon="circle" style="color:red" />
                      <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                    </font-awesome-layers>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado incompatibilidades</h5>
      </div>
    </div>

    <div class="table-mobile">
      <div v-if="dataSynchronized && holidayIncompatibilities && holidayIncompatibilities.length > 0">
        <template v-for="holidayIncompatibility in holidayIncompatibilities">
          <el-row v-for="employee in holidayIncompatibility.employees"
            :id="holidayIncompatibility.id + '-' + employee.id + '-mobile'"
            :key="holidayIncompatibility.id + '-' + employee.id + '-mobile'" class="mt-3">
            <el-card class="master-mobile-card w-100 pointer"
              @click="openModalConfigHolidayIncompatibility(holidayIncompatibility)">
              <div class="master-mobile-card__delete">
                <font-awesome-layers class="fa-2x pointer" title="Eliminar"
                  @click.stop="deleteDialog(holidayIncompatibility, employee)">
                  <font-awesome-icon icon="circle" style="color:red" />
                  <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                </font-awesome-layers>
              </div>
              <div class="master-mobile-card__title">{{ holidayIncompatibility.name }}</div>
              <div class="master-mobile-card__item">
                <span><b class="master-mobile-card__label">Empleado:</b> {{ employee.name }} {{ employee.lastName
                }}</span>
              </div>
            </el-card>
          </el-row>
        </template>
      </div>
      <div v-else class="mt-3">
        <h5>No se han encontrado incompatibilidades</h5>
      </div>
    </div>

    <SharedElementPagination class="pagination" v-model:current-page="page" :total="totalResults"
      v-model:page-size="itemsPerPage" style="padding: 0px 0px 20px 0px;"
      @change="page = $event; getHolidayIncompatibilities()" show-always />

    <!-- Confirmación de eliminacion de una incompatibilidad -->
    <SharedDeleteConfirmDialog v-model="deleteDialogShown" title="Eliminar incompatibilidad"
      :message="'¿Desea eliminar permanentemente esta incompatibilidad de ' + selectedHolidayIncompatibilityText + '?'"
      @confirm="deleteSelectedHolidayIncompatibility(selectedHolidayIncompatibility, selectedEmployee)"
      @cancel="closeStatusConfirmationModal()" />

    <!-- Modal de configuración de incompatibilidad -->
    <el-dialog v-model="showModalConfigIncompatibility" class="holiday-incompatibility-dialog"
      @closed="closeModalConfigHolidayIncompatibility()" :show-close="false" size="'medium'" width="890" :center="true"
      :lock-scroll="true" :style="{ borderRadius: `var(--el-border-radius-round)` }">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5 mt-3">{{ isUpdateHoliday ? 'Actualizar ' : 'Nueva ' }}Incompatibilidad</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="closeModalConfigHolidayIncompatibility()">
      </div>
      <div class="my-body">
        <div class="row item-modal">
          <div class="col-sm-12">
            <label class="modal-config-label">Configurador</label>
          </div>
        </div>


        <el-form ref="newHolidayIncompatibilityForm" class="newHolidayIncompatibilityForm"
          :model="selectedHolidayIncompatibility" name="newHolidayIncompatibilityForm"
          :rules="newHolidayIncompatibilityRules" status-icon @submit.prevent>
          <div class="row item-modal">
            <div class="col-sm-12 form-item">
              <el-input v-model="selectedHolidayIncompatibility.name" :label="'Nombre:'" :color="'light'"
                :param="'name'" :placeholder="'Nombre'" />
            </div>
          </div>

          <div class="row item-modal">
            <div class="col-sm-12 form-item">
              <el-input v-model.number="selectedHolidayIncompatibility.minNumberEmployees"
                :label="'Número mínimo de empleados:'" :type="'number'" :color="'light'" :param="'minNumberEmployees'"
                :placeholder="'0'" />
            </div>
          </div>

          <div class="row item-modal">
            <div class="col-sm-12 form-item">
              <!-- col-sm-6 -->
              <label class="modal-add-label">Añadir empleados</label>
              <font-awesome-icon class="btn_icon modal-add-employee-icon" icon="plus-circle" title="Añadir"
                @click="addEmployeeFromConfigModal()" />
            </div>
            <!--
            <div class="col-sm-6">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="incompatibility-active"
                        :checked="selectedHolidayIncompatibility.active ? true : false">
                    <label class="custom-control-label" for="incompatibility-active">Incompatibilidad activa</label>
                </div>
            </div>
            -->
          </div>

          <div class="row item-modal">
            <div class="col-sm-12">
              <div class="table">
                <div
                  v-if="selectedHolidayIncompatibility.employees && selectedHolidayIncompatibility.employees.length > 0">
                  <table>
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="employee in selectedHolidayIncompatibility.employees" :key="employee.id">
                        <td>
                          {{ employee.name }} {{ employee.lastName }}
                        </td>
                        <td>
                          <font-awesome-icon class="btn_icon modal-remove-employee-icon" icon="minus-circle"
                            title="Eliminar"
                            @click="deleteEmployeeFromConfigModal(selectedHolidayIncompatibility, employee)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>
                  <label class="mt-1">No hay empleados todavía...</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row item-modal offset-md-3 master-dialog-actions">
            <div class="col-sm-4 col-12">
              <button class="btn btn-block btn_red" type="button" @click="closeModalConfigHolidayIncompatibility()">
                Cancelar
              </button>
            </div>
            <div class="col-sm-4 col-12">
              <button class="btn btn_blue" type="button"
                @click="requestSaveConfigHolidayIncompatibility(selectedHolidayIncompatibility)"
                :disabled="selectedHolidayIncompatibility.name === ''">
                Aceptar
              </button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- Modal Añadir Miembros a la incompatibilidad -->
    <el-dialog v-model="showModalEmployees" class="holiday-employees-dialog" :title="'Añadir empleados'"
      :close-button-in-header="true">
      <div>
        <div class="row modal-item">
          <div class="col-12 form-item">
            <el-input v-model="searchNameModalEmployees" label="Nombre" placeholder="Nombre"
              @change="filterEmployeesByName($event)" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="table">
              <div v-if="allEmployeesList && allEmployeesList.length > 0">
                <table>
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Departamento</th>
                      <th>Puesto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="employee in allEmployeesList" :key="employee.id" class="pointer"
                      :class="{ selected: isEmployeeSelected(employee) }"
                      @click="addEmployeeToConfigIncompatibility(employee)">
                      <td>
                        {{ employee.name }} {{ employee.lastName }}
                      </td>
                      <td>
                        {{ employee.job ? employee.job.name : null }}
                      </td>
                      <td>
                        {{
                          employee.job && employee.job.department ? employee.job.department.name
                            : '--'
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <SharedElementPagination class="pagination" v-model:current-page="page" :total="allEmployeesListTotal"
                  v-model:page-size="itemsPerPage" style="padding: 0px 0px 20px 0px;"
                  @change="page = $event; getEmployees();" show-always />
              </div>
              <div v-else>
                <label>No hay empleados disponibles</label>
              </div>
            </div>
          </div>
        </div>


        <!--
          <div>
              <br/>
              <div class="row item">
                  <div class="col">
                      <button class="btn btn-block btn_red" @click="closeModalEmployees()">
                          Cancelar
                      </button>
                  </div>
                  <div class="col">

                      <button class="btn btn_blue">
                          Aceptar
                      </button>
                  </div>
              </div>
          </div>
          -->
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.my-body.my-body { margin-right: 0; }
.master-search-row .form-item { margin-bottom: 0; }
.master-create-button { width: 100%; max-width: 300px; min-height: 44px; margin-bottom: 0 !important; color: white; }
@media (max-width: 767px) { .master-search-row .form-item { margin-bottom: 12px; } }
.holiday-incompatibilities {
  .label-holiday-incompatibility {
    color: #434343;
    float: left;
    display: block;
    white-space: nowrap;

  }
}


.table-holiday-incompatibilities {
  padding-top: 40px;

  /*display: inline-block;*/
  table {

    width: 100%;
    color: #858796;

    th {
      border: 1px solid #e3e6f0;
      padding: 12px 12px 12px 20px;
      font-size: 20px;
      text-align: left;
    }

    tbody {

      tr:nth-child(odd) {
        td {
          background-color: rgba(0, 0, 0, .05);
        }
      }

      td {
        border: 1px solid #e3e6f0;
        padding: 12px;
        padding-left: 20px;
        background-color: white;
        text-align: left;

        .link-name {
          margin: auto;
          margin-left: 10px;
        }

        a {
          font-size: 18px;
          color: #4e73df;
        }
      }
    }
  }
}


.modal-config-label {
  font-size: 20px;
  font-weight: bold;
}

.item-modal {
  margin-top: 5px;
}

.table-mobile {
  display: none;
}

.master-mobile-card {
  border-radius: 16px;
}

.master-mobile-card :deep(.el-card__body) {
  position: relative;
  padding: 16px 18px;
}

.master-mobile-card__delete {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 1;
}

.master-mobile-card__title {
  color: $bg-blue;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 10px;
  padding-right: 42px;
  word-break: break-word;
}

.master-mobile-card__item {
  margin-bottom: 10px;
  word-break: break-word;
}

.master-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

.master-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.master-actions-col {
  width: 110px;
  min-width: 110px;
  text-align: center;
}

.form-item {
  margin-bottom: 5px !important;
}

.el-form-item {
  margin-bottom: 10px !important;
}

.modal-add-employee-icon {
  margin-left: 20px;
  color: green;
}

.modal-remove-employee-icon {
  color: red;
}

.modal-table-incompatibilities {
  margin-bottom: 40px;

  table {
    width: 100%;
    color: #858796;

    th {
      border: 1px solid #e3e6f0;
      padding: 12px 12px 12px 20px;
      font-size: 20px;
      text-align: left;
    }

    tbody {

      tr:nth-child(odd) {
        td {
          background-color: rgba(0, 0, 0, .05);
        }
      }

      td {
        border: 1px solid #e3e6f0;
        padding: 12px;
        padding-left: 20px;
        background-color: white;
        text-align: left;
      }
    }
  }
}

.modal-table-employees {
  padding-top: 10px;

  table {
    width: 100%;
    color: #858796;

    th {
      border: 1px solid #e3e6f0;
      padding: 12px;
      padding-left: 20px;
      font-size: 20px;
      text-align: left;
    }

    tbody {
      .selected {
        background-color: rgba(0, 0, 0, .06);

        td {
          background-color: rgba(0, 0, 0, .06);
        }
      }

      tr:nth-child(odd) {
        td {
          background-color: rgba(0, 0, 0, .05);
        }
      }

      td {
        border: 1px solid #e3e6f0;
        padding: 12px;
        padding-left: 20px;
        text-align: left;

        a {
          font-size: 18px;
          color: #4e73df;
        }
      }
    }
  }
}

.custom-checkbox {
  text-align: end;
}

.error-validation {
  border: 2px solid #F56C6C;
}

.el-dialog {
  background: #f3f0fb !important;
}

.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .title-text {
    font-size: 2.2em;
  }

  .card-search {
    padding: 20px 16px;
    background-size: 92px;
    background-position: calc(100% + 16px) 12px;
  }

  .master-search-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .master-search-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
    margin-top: 10px;
  }

  .master-search-actions .btn-search {
    width: 100%;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 14px;
  }

  :deep(.holiday-incompatibility-dialog),
  :deep(.holiday-employees-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px);
    margin-top: 4vh !important;
  }

  :deep(.holiday-incompatibility-dialog .el-dialog__body),
  :deep(.holiday-employees-dialog .el-dialog__body) {
    min-height: auto !important;
  }

  .el-dialog__body .my-header {
    align-items: flex-start;
    gap: 12px;
    padding-right: 10px;
  }

  .el-dialog__body .my-header .text-header {
    font-size: 2em;
    line-height: 1.1;
    margin-top: 0.75rem !important;
  }

  .el-dialog__body .my-header .close-icon {
    width: 26px;
    min-width: 26px;
    margin-top: 12px;
  }

  .el-dialog__body .my-body {
    margin-right: 0;
  }

  .master-dialog-actions {
    row-gap: 10px;
    margin-left: 0 !important;
  }

  .master-dialog-actions .btn {
    width: 100%;
  }
}
</style>
